import { Component, computed, Input } from '@angular/core';

@Component({
  selector: 'liberro-avatar-photo',
  standalone: false,
  templateUrl: './liberro-avatar-photo.component.html',
  styleUrl: './liberro-avatar-photo.component.less'
})
export class LiberroAvatarPhotoComponent {
  @Input() public photoUrl?: string | null = null;
  @Input() public fallbackType: 'user' | 'portfolio' | 'cash' | null = null;
  @Input() public size: '44' | '48' | '64' | '120' = '48';

  public sizeClass = computed(() => {
    const size = 'size_' + this.size;

    return ['avatar-photo', size];
  })
}
